import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import PageHeader from '../../components/PageHeader';
import { Plus, Calendar, BarChart2, Trophy, MoreHorizontal, Clock, MapPin, Users, X, Star, Gem, Edit, Trash2, Eye } from 'lucide-react';
// Mock data
const mockPolls = [{
  id: 1,
  title: 'Preferenze mobilità',
  type: 'Standard',
  status: 'Pubblicato',
  updatedAt: 'Oggi, 10:30',
  question: 'Quale mezzo usi di più?',
  options: ['Auto', 'Bici', 'Mezzi pubblici', 'A piedi']
}, {
  id: 2,
  title: 'Abitudini alimentari',
  type: 'Giornaliero',
  status: 'Programmato',
  updatedAt: 'Ieri, 15:45',
  question: 'Quanti pasti bio consumi?',
  options: ['0-1', '2-3', '4-5', 'Più di 5']
}, {
  id: 3,
  title: 'Feedback app',
  type: 'Standard',
  status: 'Bozza',
  updatedAt: '2 giorni fa',
  question: "Come valuti l'app?",
  options: ['Ottima', 'Buona', 'Sufficiente', 'Da migliorare']
}];
const mockChallenges = [{
  id: 1,
  name: 'Zero Waste Week',
  duration: '7 giorni',
  pointsType: 'Star',
  points: 500,
  status: 'Attiva',
  description: 'Riduci i tuoi rifiuti per una settimana intera'
}, {
  id: 2,
  name: 'Bike to Work',
  duration: '30 giorni',
  pointsType: 'Diamond',
  points: 50,
  status: 'Bozza',
  description: 'Vai al lavoro in bici per un mese'
}];
const mockEvents = [{
  id: 1,
  title: 'Workshop Compostaggio',
  date: '15 Maggio, 18:00',
  location: 'Milano, Green Hub',
  spots: '25/30',
  status: 'Pubblicato',
  description: 'Impara a fare il compost domestico'
}, {
  id: 2,
  title: 'Meetup Community',
  date: '22 Maggio, 19:30',
  location: 'Roma, Eco Space',
  spots: '12/50',
  status: 'Pubblicato',
  description: 'Incontro mensile della community'
}, {
  id: 3,
  title: 'Pulizia Parco',
  date: '1 Giugno, 09:00',
  location: 'Torino, Parco Valentino',
  spots: '0/100',
  status: 'Bozza',
  description: 'Pulizia collettiva del parco'
}];
const LMSProgramming = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('eventi');
  const [showCreateDrawer, setShowCreateDrawer] = useState(false);
  const [showDetailDrawer, setShowDetailDrawer] = useState(false);
  const [drawerType, setDrawerType] = useState<'poll' | 'challenge' | 'event' | null>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  // Check if we should open the drawer from navigation state
  useEffect(() => {
    if (location.state?.openDrawer) {
      const type = location.state?.type || 'poll';
      setDrawerType(type);
      setActiveTab(type === 'poll' ? 'sondaggi' : type === 'challenge' ? 'challenge' : 'eventi');
      setShowCreateDrawer(true);
      // Clear the state
      window.history.replaceState({}, document.title);
    }
  }, [location]);
  const handleCreate = () => {
    setDrawerType(activeTab === 'sondaggi' ? 'poll' : activeTab === 'challenge' ? 'challenge' : 'event');
    setShowCreateDrawer(true);
  };
  const handleCreatePoll = () => {
    setActiveTab('sondaggi');
    setDrawerType('poll');
    setShowCreateDrawer(true);
  };
  const handleViewDetail = (item: any, type: 'poll' | 'challenge' | 'event') => {
    setSelectedItem(item);
    setDrawerType(type);
    setShowDetailDrawer(true);
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Pubblicato':
      case 'Attiva':
        return 'bg-green-100 text-green-800';
      case 'Programmato':
        return 'bg-blue-100 text-blue-800';
      case 'Bozza':
        return 'bg-gray-100 text-gray-800';
      case 'Terminata':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-2380">
      <div className="w-20 flex-shrink-0" data-id="element-2381">
        <Sidebar onCreatePoll={handleCreatePoll} data-id="element-2382" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-2383">
        <Topbar data-id="element-2384" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-2385">
          <PageHeader title="Programmazione" subtitle="Gestisci sondaggi, challenge ed eventi" primaryAction={{
          label: `Crea ${activeTab === 'sondaggi' ? 'sondaggio' : activeTab === 'challenge' ? 'challenge' : 'evento'}`,
          onClick: handleCreate,
          icon: <Plus className="h-4 w-4 mr-2" data-id="element-2387" />
        }} data-id="element-2386" />

          {/* Tabs */}
          <div className="border-b border-gray-200 mb-6" data-id="element-2388">
            <nav className="-mb-px flex space-x-8" data-id="element-2389">
              {['Eventi IRL', 'Challenge', 'Sondaggi'].map(tab => {
              const tabKey = tab === 'Sondaggi' ? 'sondaggi' : tab === 'Challenge' ? 'challenge' : 'eventi';
              return <button key={tab} onClick={() => setActiveTab(tabKey)} className={`
                      whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                      ${activeTab === tabKey ? 'border-green-600 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
                    `} data-id="element-2390">
                    {tab}
                  </button>;
            })}
            </nav>
          </div>

          {/* Tab Content */}
          {activeTab === 'sondaggi' && <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2391">
              <table className="w-full" data-id="element-2392">
                <thead className="bg-gray-50" data-id="element-2393">
                  <tr data-id="element-2394">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2395">
                      Titolo
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2396">
                      Tipo
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2397">
                      Stato
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2398">
                      Ultimo aggiornamento
                    </th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2399">
                      Azioni
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200" data-id="element-2400">
                  {mockPolls.map(poll => <tr key={poll.id} className="hover:bg-gray-50" data-id="element-2401">
                      <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900" data-id="element-2402">
                        {poll.title}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2403">
                        {poll.type}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-2404">
                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadge(poll.status)}`} data-id="element-2405">
                          {poll.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2406">
                        {poll.updatedAt}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2407">
                        <button onClick={() => handleViewDetail(poll, 'poll')} className="text-green-600 hover:text-green-700" data-id="element-2408">
                          Dettagli
                        </button>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}

          {activeTab === 'challenge' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2409">
              {mockChallenges.map(challenge => <div key={challenge.id} onClick={() => handleViewDetail(challenge, 'challenge')} className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow cursor-pointer" data-id="element-2410">
                  <div className="flex justify-between items-start mb-4" data-id="element-2411">
                    <div data-id="element-2412">
                      <h3 className="text-lg font-semibold text-gray-900" data-id="element-2413">
                        {challenge.name}
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2414">
                        Durata: {challenge.duration}
                      </p>
                    </div>
                    <span className={`px-2 py-1 text-xs rounded-full ${getStatusBadge(challenge.status)}`} data-id="element-2415">
                      {challenge.status}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 mb-4" data-id="element-2416">
                    <span className={`flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-full ${challenge.pointsType === 'Diamond' ? 'bg-purple-100 text-purple-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-2417">
                      {challenge.pointsType === 'Diamond' ? <Gem className="h-3 w-3" data-id="element-2418" /> : <Star className="h-3 w-3" data-id="element-2419" />}
                      {challenge.points} Crediti{' '}
                      {challenge.pointsType === 'Diamond' ? 'Diamond' : 'Star'}
                    </span>
                    {challenge.pointsType === 'Diamond' && <span className="text-xs text-gray-500" data-id="element-2420">
                        Prova richiesta
                      </span>}
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2 mb-2" data-id="element-2421">
                    <div className="bg-green-600 h-2 rounded-full" style={{
                width: '45%'
              }} data-id="element-2422"></div>
                  </div>
                  <div className="flex justify-between text-xs text-gray-500" data-id="element-2423">
                    <span data-id="element-2424">124 partecipanti</span>
                    <span data-id="element-2425">45% completamento</span>
                  </div>
                </div>)}
            </div>}

          {activeTab === 'eventi' && <div className="space-y-6" data-id="element-2426">
              {/* Featured Event */}
              {mockEvents[0] && <div onClick={() => handleViewDetail(mockEvents[0], 'event')} className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border border-green-100 p-6 cursor-pointer hover:shadow-md transition-shadow" data-id="element-2427">
                  <div className="flex justify-between items-start" data-id="element-2428">
                    <div data-id="element-2429">
                      <span className="text-xs font-semibold text-green-600 uppercase tracking-wider mb-2 block" data-id="element-2430">
                        Prossimo evento
                      </span>
                      <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2431">
                        {mockEvents[0].title}
                      </h3>
                      <div className="flex gap-4 text-sm text-gray-600 mb-4" data-id="element-2432">
                        <span className="flex items-center gap-1" data-id="element-2433">
                          <Calendar className="h-4 w-4" data-id="element-2434" /> {mockEvents[0].date}
                        </span>
                        <span className="flex items-center gap-1" data-id="element-2435">
                          <MapPin className="h-4 w-4" data-id="element-2436" />{' '}
                          {mockEvents[0].location}
                        </span>
                      </div>
                    </div>
                    <span className={`px-2 py-1 text-xs rounded-full ${getStatusBadge(mockEvents[0].status)}`} data-id="element-2437">
                      {mockEvents[0].status}
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-2438">
                    <Users className="h-4 w-4 text-gray-500" data-id="element-2439" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-2440">
                      {mockEvents[0].spots} posti prenotati
                    </span>
                  </div>
                </div>}

              {/* Events Table */}
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2441">
                <table className="w-full" data-id="element-2442">
                  <thead className="bg-gray-50" data-id="element-2443">
                    <tr data-id="element-2444">
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2445">
                        Evento
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2446">
                        Data e Luogo
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2447">
                        Posti
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2448">
                        Stato
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2449">
                        Azioni
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-2450">
                    {mockEvents.slice(1).map(event => <tr key={event.id} className="hover:bg-gray-50" data-id="element-2451">
                        <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900" data-id="element-2452">
                          {event.title}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2453">
                          <div data-id="element-2454">{event.date}</div>
                          <div className="text-xs" data-id="element-2455">{event.location}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2456">
                          {event.spots}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-2457">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadge(event.status)}`} data-id="element-2458">
                            {event.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2459">
                          <button onClick={() => handleViewDetail(event, 'event')} className="text-green-600 hover:text-green-700" data-id="element-2460">
                            Dettagli
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}
        </main>
      </div>

      {/* Create Drawer */}
      {showCreateDrawer && <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={() => setShowCreateDrawer(false)} data-id="element-2461" />
          <div className="fixed top-0 right-0 h-full w-full sm:w-[500px] bg-white shadow-2xl z-50 overflow-y-auto" data-id="element-2462">
            <div className="p-6" data-id="element-2463">
              <div className="flex items-center justify-between mb-6" data-id="element-2464">
                <h2 className="text-xl font-bold" data-id="element-2465">
                  {drawerType === 'poll' ? 'Crea Sondaggio' : drawerType === 'challenge' ? 'Crea Challenge' : 'Crea Evento'}
                </h2>
                <button onClick={() => setShowCreateDrawer(false)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-2466">
                  <X className="h-5 w-5" data-id="element-2467" />
                </button>
              </div>

              {/* Form Content based on type */}
              <div className="space-y-6" data-id="element-2468">
                {drawerType === 'poll' && <>
                    <div data-id="element-2469">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2470">
                        Titolo
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" placeholder="Es. Preferenze mobilità" data-id="element-2471" />
                    </div>
                    <div data-id="element-2472">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2473">
                        Domanda
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" placeholder="Quale mezzo usi di più?" data-id="element-2474" />
                    </div>
                    <div data-id="element-2475">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2476">
                        Opzioni
                      </label>
                      <div className="space-y-2" data-id="element-2477">
                        <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg" placeholder="Opzione 1" data-id="element-2478" />
                        <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg" placeholder="Opzione 2" data-id="element-2479" />
                        <button className="text-sm text-green-600 font-medium hover:underline" data-id="element-2480">
                          + Aggiungi opzione
                        </button>
                      </div>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-2481">
                      <input type="checkbox" id="daily" className="rounded text-green-600 focus:ring-green-600" data-id="element-2482" />
                      <label htmlFor="daily" className="text-sm font-medium text-gray-700" data-id="element-2483">
                        Sondaggio del giorno
                      </label>
                    </div>
                  </>}

                {drawerType === 'challenge' && <>
                    <div data-id="element-2484">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2485">
                        Nome Challenge
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2486" />
                    </div>
                    <div data-id="element-2487">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2488">
                        Descrizione
                      </label>
                      <textarea className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" rows={3} data-id="element-2489" />
                    </div>
                    <div className="grid grid-cols-2 gap-4" data-id="element-2490">
                      <div data-id="element-2491">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2492">
                          Durata (giorni)
                        </label>
                        <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg" data-id="element-2493" />
                      </div>
                      <div data-id="element-2494">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2495">
                          Crediti
                        </label>
                        <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg" data-id="element-2496" />
                      </div>
                    </div>
                    <div data-id="element-2497">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2498">
                        Tipo Ricompensa
                      </label>
                      <div className="flex gap-4" data-id="element-2499">
                        <label className="flex items-center gap-2" data-id="element-2500">
                          <input type="radio" name="reward" className="text-green-600 focus:ring-green-600" data-id="element-2501" />
                          <Star className="h-4 w-4 text-amber-500" data-id="element-2502" />
                          <span className="text-sm" data-id="element-2503">Crediti Star</span>
                        </label>
                        <label className="flex items-center gap-2" data-id="element-2504">
                          <input type="radio" name="reward" className="text-green-600 focus:ring-green-600" data-id="element-2505" />
                          <Gem className="h-4 w-4 text-purple-500" data-id="element-2506" />
                          <span className="text-sm" data-id="element-2507">Crediti Diamond</span>
                        </label>
                      </div>
                    </div>
                  </>}

                {drawerType === 'event' && <>
                    <div data-id="element-2508">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2509">
                        Titolo Evento
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2510" />
                    </div>
                    <div className="grid grid-cols-2 gap-4" data-id="element-2511">
                      <div data-id="element-2512">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2513">
                          Data
                        </label>
                        <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-lg" data-id="element-2514" />
                      </div>
                      <div data-id="element-2515">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2516">
                          Ora
                        </label>
                        <input type="time" className="w-full px-3 py-2 border border-gray-300 rounded-lg" data-id="element-2517" />
                      </div>
                    </div>
                    <div data-id="element-2518">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2519">
                        Luogo
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg" placeholder="Città, Indirizzo" data-id="element-2520" />
                    </div>
                    <div data-id="element-2521">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2522">
                        Posti disponibili
                      </label>
                      <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg" data-id="element-2523" />
                    </div>
                  </>}
              </div>

              {/* Footer Actions */}
              <div className="flex gap-3 mt-8 pt-6 border-t border-gray-200" data-id="element-2524">
                <button onClick={() => setShowCreateDrawer(false)} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2525">
                  Annulla
                </button>
                <button onClick={() => {
              alert('Elemento creato con successo!');
              setShowCreateDrawer(false);
            }} className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700" data-id="element-2526">
                  Pubblica
                </button>
              </div>
            </div>
          </div>
        </>}

      {/* Detail Drawer */}
      {showDetailDrawer && selectedItem && <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={() => setShowDetailDrawer(false)} data-id="element-2527" />
          <div className="fixed top-0 right-0 h-full w-full sm:w-[500px] bg-white shadow-2xl z-50 overflow-y-auto" data-id="element-2528">
            <div className="p-6" data-id="element-2529">
              <div className="flex items-center justify-between mb-6" data-id="element-2530">
                <h2 className="text-xl font-bold" data-id="element-2531">
                  {drawerType === 'poll' ? 'Dettagli Sondaggio' : drawerType === 'challenge' ? 'Dettagli Challenge' : 'Dettagli Evento'}
                </h2>
                <button onClick={() => setShowDetailDrawer(false)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-2532">
                  <X className="h-5 w-5" data-id="element-2533" />
                </button>
              </div>

              <div className="space-y-6" data-id="element-2534">
                {drawerType === 'poll' && <>
                    <div data-id="element-2535">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2536">
                        Titolo
                      </label>
                      <input type="text" defaultValue={selectedItem.title} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600" data-id="element-2537" />
                    </div>
                    <div data-id="element-2538">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2539">
                        Domanda
                      </label>
                      <input type="text" defaultValue={selectedItem.question} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600" data-id="element-2540" />
                    </div>
                    <div data-id="element-2541">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2542">
                        Opzioni
                      </label>
                      {selectedItem.options?.map((option: string, index: number) => <input key={index} type="text" defaultValue={option} className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-2" data-id="element-2543" />)}
                    </div>
                    <div data-id="element-2544">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2545">
                        Stato
                      </label>
                      <select defaultValue={selectedItem.status} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600" data-id="element-2546">
                        <option value="Bozza" data-id="element-2547">Bozza</option>
                        <option value="Pubblicato" data-id="element-2548">Pubblicato</option>
                        <option value="Programmato" data-id="element-2549">Programmato</option>
                      </select>
                    </div>
                  </>}

                {drawerType === 'challenge' && <>
                    <div data-id="element-2550">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2551">
                        Nome
                      </label>
                      <input type="text" defaultValue={selectedItem.name} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600" data-id="element-2552" />
                    </div>
                    <div data-id="element-2553">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2554">
                        Descrizione
                      </label>
                      <textarea defaultValue={selectedItem.description} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600" rows={3} data-id="element-2555" />
                    </div>
                    <div className="grid grid-cols-2 gap-4" data-id="element-2556">
                      <div data-id="element-2557">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2558">
                          Durata
                        </label>
                        <input type="text" defaultValue={selectedItem.duration} className="w-full px-3 py-2 border border-gray-300 rounded-lg" data-id="element-2559" />
                      </div>
                      <div data-id="element-2560">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2561">
                          Crediti
                        </label>
                        <input type="number" defaultValue={selectedItem.points} className="w-full px-3 py-2 border border-gray-300 rounded-lg" data-id="element-2562" />
                      </div>
                    </div>
                    <div data-id="element-2563">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2564">
                        Stato
                      </label>
                      <select defaultValue={selectedItem.status} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600" data-id="element-2565">
                        <option value="Bozza" data-id="element-2566">Bozza</option>
                        <option value="Attiva" data-id="element-2567">Attiva</option>
                        <option value="Terminata" data-id="element-2568">Terminata</option>
                      </select>
                    </div>
                  </>}

                {drawerType === 'event' && <>
                    <div data-id="element-2569">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2570">
                        Titolo
                      </label>
                      <input type="text" defaultValue={selectedItem.title} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600" data-id="element-2571" />
                    </div>
                    <div data-id="element-2572">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2573">
                        Descrizione
                      </label>
                      <textarea defaultValue={selectedItem.description} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600" rows={3} data-id="element-2574" />
                    </div>
                    <div data-id="element-2575">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2576">
                        Data e Ora
                      </label>
                      <input type="text" defaultValue={selectedItem.date} className="w-full px-3 py-2 border border-gray-300 rounded-lg" data-id="element-2577" />
                    </div>
                    <div data-id="element-2578">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2579">
                        Luogo
                      </label>
                      <input type="text" defaultValue={selectedItem.location} className="w-full px-3 py-2 border border-gray-300 rounded-lg" data-id="element-2580" />
                    </div>
                    <div data-id="element-2581">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2582">
                        Posti
                      </label>
                      <input type="text" defaultValue={selectedItem.spots} className="w-full px-3 py-2 border border-gray-300 rounded-lg" data-id="element-2583" />
                    </div>
                    <div data-id="element-2584">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2585">
                        Stato
                      </label>
                      <select defaultValue={selectedItem.status} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600" data-id="element-2586">
                        <option value="Bozza" data-id="element-2587">Bozza</option>
                        <option value="Pubblicato" data-id="element-2588">Pubblicato</option>
                      </select>
                    </div>
                  </>}
              </div>

              <div className="flex gap-3 mt-8 pt-6 border-t border-gray-200" data-id="element-2589">
                <button onClick={() => setShowDetailDrawer(false)} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2590">
                  Annulla
                </button>
                <button onClick={() => {
              alert('Modifiche salvate!');
              setShowDetailDrawer(false);
            }} className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700" data-id="element-2591">
                  Salva modifiche
                </button>
              </div>
            </div>
          </div>
        </>}
    </div>;
};
export default LMSProgramming;